[
  {
    "key": "linkedin-post",
    "label": "LinkedIn",
    "platform": "linkedin",
    "subtype": "post",
    "outputFormat": "text",
    "lengthUnit": "words",
    "minLength": 300,
    "maxLength": 600,
    "supportsThread": false,
    "supportsScheduling": true,
    "supportsNotionSync": true,
    "notionPlatformLabel": "LinkedIn",
    "publishingStability": "stable",
    "publishingMode": "linkedin-post-api",
    "archiveCategory": "social-post"
  },
  {
    "key": "x-post",
    "label": "X / Twitter",
    "platform": "x",
    "subtype": "post",
    "outputFormat": "text",
    "lengthUnit": "chars",
    "minLength": null,
    "maxLength": 280,
    "supportsThread": true,
    "supportsScheduling": true,
    "supportsNotionSync": true,
    "notionPlatformLabel": "X / Twitter",
    "publishingStability": "stable",
    "publishingMode": "x-post-api",
    "archiveCategory": "social-post"
  },
  {
    "key": "linkedin-article",
    "label": "LinkedIn Article",
    "platform": "linkedin",
    "subtype": "article",
    "outputFormat": "text",
    "lengthUnit": "words",
    "minLength": 800,
    "maxLength": 1200,
    "supportsThread": false,
    "supportsScheduling": true,
    "supportsNotionSync": true,
    "notionPlatformLabel": "LinkedIn Article",
    "publishingStability": "manual",
    "publishingMode": "export-markdown",
    "archiveCategory": "article"
  },
  {
    "key": "x-article",
    "label": "X Article",
    "platform": "x",
    "subtype": "article",
    "outputFormat": "text",
    "lengthUnit": "words",
    "minLength": 500,
    "maxLength": 2500,
    "supportsThread": false,
    "supportsScheduling": true,
    "supportsNotionSync": true,
    "notionPlatformLabel": "X Article",
    "publishingStability": "experimental",
    "publishingMode": "x-article-api",
    "archiveCategory": "article"
  },
  {
    "key": "newsletter-issue",
    "label": "Newsletter",
    "platform": "newsletter",
    "subtype": "issue",
    "outputFormat": "text",
    "lengthUnit": "words",
    "minLength": 400,
    "maxLength": 600,
    "supportsThread": false,
    "supportsScheduling": true,
    "supportsNotionSync": true,
    "supportsSubstackPush": true,
    "notionPlatformLabel": "Newsletter",
    "publishingStability": "manual",
    "publishingMode": "export-markdown",
    "archiveCategory": "newsletter"
  },
  {
    "key": "linkedin-carousel",
    "label": "LinkedIn Carousel",
    "platform": "linkedin",
    "subtype": "carousel",
    "outputFormat": "slides-json",
    "lengthUnit": null,
    "minLength": 5,
    "maxLength": 8,
    "supportsThread": false,
    "supportsScheduling": false,
    "supportsNotionSync": true,
    "notionPlatformLabel": "LinkedIn Carousel",
    "publishingStability": "manual",
    "publishingMode": "manual-upload",
    "archiveCategory": "carousel"
  },
  {
    "key": "instagram-post",
    "label": "Instagram",
    "platform": "instagram",
    "subtype": "post",
    "outputFormat": "text",
    "lengthUnit": "chars",
    "minLength": null,
    "maxLength": 2200,
    "supportsThread": false,
    "supportsScheduling": true,
    "supportsNotionSync": false,
    "notionPlatformLabel": "Instagram",
    "publishingStability": "experimental",
    "publishingMode": "instagram-api",
    "archiveCategory": "social-post"
  }
]
